import Panel from '~/components/Panel'
import { Checkbox, FormGroup, Input, Label } from '~/components/unform'

const AuxiliarySection = () => {
  return (
    <Panel title="Auxiliary" isCollapsible initialCollapsibleState={false}>
      <FormGroup className="d-flex justify-content-between">
        <Label className="w-75">Session ID</Label>
        <Input name="session_id" placeholder="Session ID" />
      </FormGroup>

      <FormGroup className="d-flex justify-content-between mt-2">
        <Label className="w-75">User ID</Label>
        <Input name="user_id" placeholder="User ID" />
      </FormGroup>

      <FormGroup className="d-flex justify-content-between mt-2">
        <Label className="w-75">Store ID</Label>
        <Input name="store_id" placeholder="Store ID" />
      </FormGroup>

      <FormGroup className="d-flex justify-content-between mt-2">
        <Label className="w-75">Channel</Label>
        <Input name="channel" placeholder="Channel" />
      </FormGroup>

      <section className="d-flex justify-content-between mt-2">
        <FormGroup className="w-50">
          <Checkbox name="dedup_campaign_ads" label="Dedup Campaign Ads" />
        </FormGroup>

        <FormGroup className="w-50">
          <Checkbox name="dedup_ads" label="Dedup Ads" />
        </FormGroup>
      </section>
    </Panel>
  )
}

export default AuxiliarySection
